<template>
  <!-- prettier-ignore -->
  <ovp-modal
    v-model="isOpen"
    @close="resetForm"
  >
    <div class="pin-dialog">

      <h1 v-text="$t('cobrowse.title')"/>
      <p v-text="$t('cobrowse.subtitle')"/>

      <ovp-form
        class="pin-dialog__form"
        name="pin-dialog"
        :validator="$v.form"
        @submit="submit">

        <ovp-text-input
          v-model="form.pin"
          autofocus
          autocomplete="do-not-autocomplete"
          name="pin"
          type="password"
          :mask="'######'"
          :max-length="6"
          :delay="0"
          class="pin-dialog__pin"
          :title="$t('cobrowse.pin')"
          :placeholder="$t('cobrowse.pin')"
          :validate="$v.form.pin"
          theme="dark"
        />

        <ovp-drop-down
          v-model="form.reason"
          name="reason"
          :title="$t('cobrowse.reason')"
          :validate="$v.form.reason"
          :options="reasons"
          theme="dark"
        />

        <ovp-checkbox
          v-model="form.agb"
          name="agb"
          :validate="$v.form.agb"
          :title="$t('cobrowse.agreement')"
        />

        <ovp-button
          primary
          type="submit"
          v-text="$t('cobrowse.start')"
        />

      </ovp-form>
    </div>
  </ovp-modal>
</template>

<script>
import OvpModal from '@/components/Modal/Modal'
import { maxLength, numeric, required } from 'vuelidate/lib/validators'

import { EVENT_COBROWSE_REQUEST_PIN } from '@/config/events'

export default {
  name: 'OvpPinDialog',

  components: {
    OvpModal,
  },

  data() {
    return {
      isOpen: false,
      form: {
        pin: null,
        reason: null,
        agb: null,
      },
    }
  },

  validations: {
    form: {
      pin: {
        required,
        numeric,
        maxLength: maxLength(6),
      },
      reason: { required },
      agb: { required },
    },
  },

  created() {
    this.$EventBus.$on(EVENT_COBROWSE_REQUEST_PIN, this.openDialog)
  },

  beforeDestroy() {
    this.$EventBus.$off(EVENT_COBROWSE_REQUEST_PIN, this.openDialog)
  },

  computed: {
    reasons() {
      const items = this.$t('cobrowse.reasonList')
      if (!Array.isArray(items)) return
      return items.map(item => {
        return {
          text: item,
          value: item,
        }
      })
    },
  },

  methods: {
    openDialog() {
      this.isOpen = true
      this.$v.$reset()
    },

    resetForm() {
      this.form = {
        pin: null,
        reason: null,
        agb: null,
      }
    },

    submit() {
      const { pin, reason } = this.form
      this.$emit('submit', { pin, reason })
      this.isOpen = false
      this.resetForm()
    },
  },
}
</script>

<style name="mobile" scoped>
.pin-dialog {
  padding: 15px 15px 0 15px;
  color: var(--c-black);
  font-size: 15px;
}

.pin-dialog__form {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.pin-dialog__pin {
  width: 200px;
}
</style>
